<template>
    <footer class="row py-3 bg-white fixed-bottom bottom-0">
        <div class="col-md-1 col-xxl-2 p-0 d-flex justify-content-end align-items-center me-5">
            <img :src="require('../../../public/img/icons/favicon-32x32.png')" width="32" height="32" alt="IconLogo"/>
        </div>
        <ul class="col mt-3 pb-3 nav lh-1 d-flex justify-content-start">
            <li class="nav-item">
                <p class=" bottom-link font-grey fw-bold">Don't have a RebateKey account yet?</p>
                <a href="https://rebatekey.com/register" target="_blank" class="mt-3 text-decoration-none
                font-blue fw-bold" rel="noreferrer">Create your free account</a>
            </li>
        </ul>
    </footer>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
    name: "footerChromeWelcome"
})
</script>

<style lang="scss" scoped>

.font-grey {
    color: $footer-grey;
}

.font-blue {
    color: $footer-blue;
}
</style>